import { combineReducers } from 'redux';
import { reducer as updateReducer } from './updateModule';
import { reducer as detailsReducer } from './detailsModule';

export default combineReducers({
	update: updateReducer,
	details: detailsReducer,
});
